import type { ReactNode } from "react"

type IProps = {
    children: ReactNode,
    to: string,
    className?: string
}

const LinkComponent = ({ children, className = '', to, ...otherProps }: IProps) => {
    return (
        <a href={to} className={`${className}`} {...otherProps}>{children}</a>
    )
}

export default LinkComponent